import React from 'react';
import { FunctionComponent } from 'react';
import config from '@config';
import SmoothImage from '@xFrame4/components/common/SmoothImage';
import CtaArrowIcon from '@components/common/CtaArrowIcon';
import { MiniSliderThumbnail } from './HomeMiniSlider';

interface HomeMiniSliderDesktopFirstImageProps
{
    miniSliderThumbnail: MiniSliderThumbnail;
}

/**
 * Component: the first mini slider image is show separately on desktop.
 */
const HomeMiniSliderDesktopFirstImage: FunctionComponent<HomeMiniSliderDesktopFirstImageProps> = (props) =>
{
    const image = props.miniSliderThumbnail.alterImage ?? props.miniSliderThumbnail.image;

    /** Render */
    return (
        <div className="mini-slider-slide-desktop-first-image h-100 cursor-pointer">
            <SmoothImage 
                src={image.url}
                width={image.width}
                height={image.height}
                className="w-100 h-100 base-box"
                alt={props.miniSliderThumbnail.name}
            />
            <div className="mini-slider-slide-desktop-first-image-overlay p-3 d-flex flex-column base-box">
                <div className="mini-slider-slide-desktop-first-image-overlay--texts flex-grow-1">
                    <div className="d-flex justify-content-start">
                        <div className="mini-slider-slide-name text-uppercase">{props.miniSliderThumbnail.name}</div>
                    </div>
                    <div className="d-flex justify-content-start">
                        <div className="mini-slider-slide-text1">{props.miniSliderThumbnail.text1}</div>
                    </div>
                </div>
                <div 
                    className="d-flex justify-content-start align-items-center h-10"
                    onClick={() => window.location.href = config.appUrl + props.miniSliderThumbnail.url}
                >
                    <div className="mini-slider-slide-text2">{props.miniSliderThumbnail.text2}</div>
                    <CtaArrowIcon 
                        size={8}
                        variant="light"
                    />
                </div>
            </div>
        </div>
    );
}

export default HomeMiniSliderDesktopFirstImage;